import React from 'react'
import styled from 'styled-components'
import { Grid as BaseGrid, Hidden as BaseHidden } from '@material-ui/core'
import { CheckBox as BaseCheckBox } from '@chilecompra/react-kit/components'

export const Root = styled.div`
  margin: 0;
  padding: 0 0 130px;
  width: 100%;
`

export const PhoneContent = styled.div``

export const PhoneSection = styled.div`
  display: grid;
  grid-template-columns: 155px auto;
  grid-column-gap: 10px;
`

export const Label = styled.label`
  color: ${props => props.theme.palette.brand.black3};
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1.125px;
  line-height: 14px;
  margin: 0 0 0.5rem;
  text-transform: uppercase;
`

export const LinkHelp = styled('a')`
  align-items: center;
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  text-decoration: none;
  pointer-events: visible;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
    text-decoration: underline;
  }
`

export const Required = styled(({ ...props }) => <span {...props}>*</span>)`
  color: ${props => props.theme.palette.brand.black3};
  font-size: 1rem;
`

export const Section = styled(({ margin, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth || 'initial'};
  padding: ${props => props.padding || '0'};
  text-align: left;
`

export const Conditions = styled.div`
  font-size: 13px;
  font-weight: 300;
  line-height: 18px;
  margin: 25px 0 0;

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`

export const CheckBox = styled(BaseCheckBox)`
  &.MuiFormControlLabel-root {
    margin: 0;
  }

  &.MuiFormControlLabel-root .MuiCheckbox-root {
    margin: 0;
    padding: 0;
  }
`

export const Link = styled.a``

export const Image = styled.img`
  width: 100%;
  ${props => props.theme.breakpoints.down('xs')} {
    max-width: 140px;
    display: block;
    margin: 0 auto;
  }
`

export const Instructions = styled.section`
  font-size: 22px;
  font-weight: 300;
  line-height: 26px;
  margin-top: 28px;

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`

export const Strong = styled.span`
  font-weight: bold;
`

export const Title = styled.h1`
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 34px;
  font-weight: 300;
  line-height: 45px;

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`

export const Hidden = styled(BaseHidden)``

export const DesktopNavigation = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 30px;
  margin: 0;
  width: 100%;
`

export const MobileNavigation = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.custom.ghostWhite};
  bottom: 0;
  box-shadow: 0 -3px 10px ${props => props.theme.palette.custom.ghostBlack};
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 32px;
  height: 90px;
  justify-content: center;
  left: 0;
  position: fixed;
  width: 100%;
`
